module.exports = __webpack_public_path__ + "static/media/surtidor-rojo.7c56e930.svg";